import { atom } from "recoil";
import { UserInfoListDto } from "../services";

export const SelectedUserState = atom<UserInfoListDto | null>({
  key: "selectedUserState",
  default: null,
});
